import React from 'react';
import { Title, usePermissions } from 'react-admin';

import { Card } from '@material-ui/core';

function AcessoNegado({ titulo = 'Acesso negado', mensagem }) {
  return (
    <Card
      style={{
        padding: 40,
        borderRadius: 20,
        maxWidth: 500,
        margin: '60px auto',
        textAlign: 'center',
      }}
    >
      <Title title={titulo} />

      <div style={{ fontSize: 60, marginBottom: 16 }}>🔒</div>

      <h2
        style={{ margin: 0, marginBottom: 12, fontSize: 24, fontWeight: 600 }}
      >
        {titulo}
      </h2>

      <p style={{ margin: 0, color: '#666', fontSize: 16, lineHeight: 1.5 }}>
        {mensagem || 'Você não possui permissão para acessar esta página.'}
      </p>
    </Card>
  );
}

export function ProtegerPagina({
  permissao,
  children,
  mensagem = 'Você não possui permissão para acessar esta página de vendas.',
}) {
  const { permissions, loading } = usePermissions();

  if (loading) return null;

  const temPermissao = !!permissions?.[permissao];

  if (!temPermissao) {
    return <AcessoNegado mensagem={mensagem} />;
  }

  return children;
}
